module.exports = __webpack_public_path__ + "img/29.ef7829db.jpg";